import React, {useState, useMemo} from 'react'
import { IProductsWithVarietyItem } from '../../../../../../modules/API/Defaults/models/compliteProducts'
import SearchFromTheList from '../../../../../../generic/customSearchComponents/SearchFromTheList'

type Props = {
  list: IProductsWithVarietyItem[]
  defaultProductID: number
  defaultVarietyID: number
  setProductID: React.Dispatch<React.SetStateAction<number>> | ((id: number) => void)
  setVarietyID: React.Dispatch<React.SetStateAction<number>> | ((id: number) => void)
  required?: boolean
}

const SearchProductWithVariety = ({
  defaultProductID, defaultVarietyID, list, 
  setProductID, setVarietyID, required
}: Props) => {
  const defaultProduct = list?.filter(item => 
    item.ProductID === defaultProductID 
      && item.VarietyID === defaultVarietyID
  )[0]
  const [isOpenDropDown, setIsOpenDropDown] = useState<boolean>(false)
  const [selectedProduct, setSelectedProduct] = useState<IProductsWithVarietyItem | null>(defaultProduct || null)
  const [search, setSearch] = useState<string>(`${defaultProduct?.ProductDesc?.trim() || ''} ${defaultProduct?.VarietyDesc?.trim() || ''}`.trim() || '')
  const handleSearch = (e: string) => {
    if(e === '') {
      setSelectedProduct(null)
      setProductID(0)
      setVarietyID(0)
      setIsOpenDropDown(false)
      setSearch('')
      return
    }
    setIsOpenDropDown(true)
    setSearch(e)
  }
  const handleSelect = (item: IProductsWithVarietyItem) => {
    setProductID(item.ProductID)
    setVarietyID(item.VarietyID)
    setSearch(`${item.ProductDesc.trim()} ${item.VarietyDesc.trim()}`)
    setSelectedProduct(item)
    setIsOpenDropDown(false)
  }
  const markedLinePattern = (item: IProductsWithVarietyItem) => {
    return !!item.isHighlighted
  }
  const render = useMemo(() => {
    if(!list) return []
    return list.filter(item => 
      `${item.ProductDesc?.trim()} ${item.VarietyDesc?.trim()}`.toLocaleLowerCase().includes(search.toLocaleLowerCase())
    )
  }, [list, search])
  return (
    <SearchFromTheList 
      input={search}
      list={render}
      isOpenList={isOpenDropDown}
      placeHolder={'חפש פריט'}
      selectFunc={handleSelect}
      searchFunc={handleSearch}
      isNeedFullObject
      itemDisplayName='ProductDesc'
      itemSecondaryName={'VarietyDesc'}
      nameIdElement='ProductID'
      markedLinePattern={markedLinePattern}
      highlightColor={'#80E081'}
      required={required}
      size={'full'}
    />
  )
}

export default SearchProductWithVariety